// API
export const GET_SECTIONS_LIST_API = '/sections/page/label';
export const GET_SECTION_CONTENT_API =
	'/sections/id/content?offset=0&limit=mainLimit';

// Queries
export const QUERY_SECTIONS_LIST = 'QUERY_SECTIONS_LIST';
export const QUERY_SECTION_CONTENT = 'QUERY_SECTION_CONTENT';
